/** Static labels for the support screen. Agent answers follow the customer's language. */
export const UI_LANG_STORAGE_KEY = "alfamall-support-ui-lang";

export const ORDER_STATUS_LABELS = {
  en: {
    placed: "Order placed",
    confirmed: "Confirmed",
    packed: "Packed",
    shipped: "Shipped",
    out_for_delivery: "Out for delivery today",
    delivered: "Delivered",
    cancelled: "Cancelled",
    return_requested: "Return requested",
    returned: "Returned",
    refunded: "Refunded",
  },
  ur: {
    placed: "Order mil gaya hai",
    confirmed: "Confirm ho gaya hai",
    packed: "Pack ho gaya hai",
    shipped: "Rawana ho gaya hai",
    out_for_delivery: "Aaj delivery ke liye nikla hai",
    delivered: "Deliver ho gaya hai",
    cancelled: "Cancel ho gaya hai",
    return_requested: "Return ki request mil gayi hai",
    returned: "Wapas mil gaya hai",
    refunded: "Refund ho gaya hai",
  },
};

export const COPY = {
  en: {
    heading: "AlfaMall Support",
    tagline: "Tell us your problem, by voice or by typing.",
    taglineIsUrduScript: false,
    subtitle:
      "Order, delivery, return, refund or payment — ask by speaking or typing. Urdu, Roman Urdu or English, whichever is easier for you.",
    langToggleAria: "Choose screen language",
    langEnglish: "English",
    langUrdu: "اردو",
    sampleBannerStrong: "Setup note:",
    sampleBannerBefore:
      "the approved knowledge base is not loaded yet. The agent is only answering process questions and forwarding policy questions to the human team — that's the safe behaviour. Run migration 0004 and publish approved content in",
    sampleBannerCode: "support_knowledge",
    sampleBannerAfter: ".",
    demoBannerStrong: "Demo content is live:",
    demoBannerText:
      'the policies the agent is quoting right now were added for testing only — they are not AlfaMall’s approved policies. Click "Remove demo content" on the admin screen once the real content is loaded.',
    overridesBannerStrong: "Setup incomplete:",
    overridesBannerText:
      'the ElevenLabs agent did not accept this session’s prompt override, so it is running on the old dashboard prompt — without the support persona or grounding rules. In the dashboard, go to Security → Overrides and turn ON "System prompt" and "First message".',
    conversationAriaLabel: "Conversation",
    greetingTitle: "Assalam-o-Alaikum. I'm AlfaMall's support agent.",
    greetingBody:
      "Tell me your order number and I'll check the status for you, or just tell me what's wrong.",
    checkingText: "Checking...",
    questionLabelSr: "Type your question",
    questionPlaceholderCallActive: "Call in progress — ask by speaking",
    questionPlaceholder: "Type your question here...",
    sendAria: "Send question",
    listenAria: "Listen to the answer",
    orderCheckHeading: "Check Order",
    orderNumberLabel: "Order number",
    mobileLabel: "Registered mobile (optional)",
    statusCheckButton: "Check Status",
    statusCheckingButton: "Checking...",
    orderLabel: "Order",
    statusLabel: "Status",
    courierLabel: "Courier",
    trackingLabel: "Tracking",
    expectedLabel: "Expected",
    paymentLabel: "Payment",
    totalLabel: "Total",
    itemsLabel: "Items",
    unverifiedNote: "Only the status is shown without the registered mobile number.",
    ticketHeading: "Sent to the Support Team",
    referenceLabel: "Reference number:",
    safetyHeading: "Your Safety",
    safetyBody:
      "This agent will never ask you for an OTP, PIN, password, or full card number. If anyone does — even claiming to be from AlfaMall — it's fraud.",
    capabilitiesHeading: "What the Agent Can Do",
    capability1: "Tell you the order status and expected delivery",
    capability2: "Share AlfaMall's approved policy",
    capability3: "Pass your issue on to the human support team",
    capabilitiesNote:
      "Account changes, cancellations, refunds or payments — the agent cannot do these; only the human team can.",
    talkToPerson: "Talk to a person",
    orderMissing: "Enter an order number.",
    orderNotFound: "No order was found for that number.",
    handoffFailed: "Could not reach the support team. Try again.",
    handoffSent: "Your request has been sent.",
    navHome: "Home",
    navSupport: "Voice Support",
    navAdmin: "Admin",
    announce: "AlfaMall Support — Bol Kar Apna Masla Batayein, Urdu Ya English Mein",
    voiceStart: "Talk by Voice",
    voiceEnd: "End Call",
    voiceStartAria: "Start voice call",
    voiceEndAria: "End call",
    micError: "Microphone access was not granted. Allow the microphone from your browser's lock icon.",
    statusIdle: "",
    statusConnecting: "Connecting...",
    statusListening: "Listening...",
    statusSpeaking: "Speaking...",
    statusError: "Call trouble",
    productsFor: "Products for",
    inStock: "In stock",
    outOfStock: "Out of stock",
  },
  ur: {
    heading: "AlfaMall Support",
    tagline: "بول کر اپنا مسئلہ بتائیں",
    taglineIsUrduScript: true,
    subtitle:
      "Order, delivery, return, refund ya payment — bol kar ya likh kar poochein. Urdu, Roman Urdu ya English, jo aasan ho.",
    langToggleAria: "Screen ki language chunein",
    langEnglish: "English",
    langUrdu: "اردو",
    sampleBannerStrong: "Setup note:",
    sampleBannerBefore:
      "approved knowledge base abhi load nahi hui. Agent sirf process ke sawal ka jawab de raha hai aur policy ke sawal human team ko forward kar raha hai — yehi mehfooz behaviour hai. Migration 0004 chalayein aur",
    sampleBannerCode: "support_knowledge",
    sampleBannerAfter: "mein approved content publish karein.",
    demoBannerStrong: "Demo content live hai:",
    demoBannerText:
      'is waqt agent jo policies bata raha hai woh testing ke liye daali gayi hain — AlfaMall ki approved policies nahi. Admin screen se "Demo content hatayein" par click karein jab asli content load ho jaye.',
    overridesBannerStrong: "Setup adhoora hai:",
    overridesBannerText:
      'ElevenLabs agent ne is session ka prompt override qubool nahi kiya, is liye woh dashboard wale purane prompt par chal raha hai — support persona aur grounding rules ke baghair. Dashboard mein Security → Overrides se "System prompt" aur "First message" ON karein.',
    conversationAriaLabel: "Guftagu",
    greetingTitle: "Assalam-o-Alaikum. Main AlfaMall ka support agent hoon.",
    greetingBody:
      "Aap ka order number bata dein to status check kar deta hoon, ya seedha apna masla bata dein.",
    checkingText: "Check kar raha hoon...",
    questionLabelSr: "Apna sawal likhein",
    questionPlaceholderCallActive: "Call jari hai — bol kar poochein",
    questionPlaceholder: "Apna sawal yahan likhein...",
    sendAria: "Sawal bhejein",
    listenAria: "Jawab sunein",
    orderCheckHeading: "Order Check Karein",
    orderNumberLabel: "Order number",
    mobileLabel: "Registered mobile (optional)",
    statusCheckButton: "Status Check Karein",
    statusCheckingButton: "Check ho raha hai...",
    orderLabel: "Order",
    statusLabel: "Status",
    courierLabel: "Courier",
    trackingLabel: "Tracking",
    expectedLabel: "Expected",
    paymentLabel: "Payment",
    totalLabel: "Total",
    itemsLabel: "Items",
    unverifiedNote: "Mobile number ke baghair sirf status dikh raha hai.",
    ticketHeading: "Support Team Ko Bhej Diya",
    referenceLabel: "Reference number:",
    safetyHeading: "Aap Ki Hifazat",
    safetyBody:
      "Yeh agent aap se OTP, PIN, password ya card ka poora number kabhi nahi maangega. Agar koi maange — chahe woh AlfaMall ka numainda kehlaye — woh fraud hai.",
    capabilitiesHeading: "Agent Kya Kar Sakta Hai",
    capability1: "Order ka status aur expected delivery batana",
    capability2: "AlfaMall ki approved policy batana",
    capability3: "Masla human support team tak pahunchana",
    capabilitiesNote:
      "Account mein tabdeeli, cancel, refund ya payment — yeh agent nahi kar sakta, human team karti hai.",
    talkToPerson: "Insaan Se Baat Karein",
    orderMissing: "Order number likhein.",
    orderNotFound: "Is number par koi order nahi mila.",
    handoffFailed: "Support team tak request nahi pahunch saki. Dobara koshish karein.",
    handoffSent: "Aap ki request bhej di gayi hai.",
    navHome: "Home",
    navSupport: "Voice Support",
    navAdmin: "Admin",
    announce: "AlfaMall Support — Bol Kar Apna Masla Batayein, Urdu Ya English Mein",
    voiceStart: "Voice Par Baat Karein",
    voiceEnd: "Call Khatam Karein",
    voiceStartAria: "Voice call shuru karein",
    voiceEndAria: "Call khatam karein",
    micError: "Microphone ki ijazat nahi mili. Browser ke lock icon se microphone Allow karein.",
    statusIdle: "",
    statusConnecting: "Connect ho raha hai...",
    statusListening: "Sun raha hoon...",
    statusSpeaking: "Bol raha hoon...",
    statusError: "Call mein masla",
    productsFor: "Products",
    inStock: "In stock",
    outOfStock: "Out of stock",
  },
};
